import type { Movie } from '@/types/movie';

export const movies: Movie[] = [
  {
    id: '1',
    title: '暗夜追凶',
    year: 2025,
    rating: 8.7,
    genres: ['犯罪', '悬疑'],
    director: '陈默',
    actors: ['林淮', '苏晴', '赵文远'],
    duration: 128,
    region: '中国大陆',
    tagline: '每一个雨夜，都藏着一个不肯醒来的真相。',
    synopsis:
      '连日的暴雨淹没了旧城区的街道，一桩尘封十二年的悬案却因一具意外浮出水面的尸体重见天日。刑警林淮被紧急调回曾经让他身败名裂的辖区，面对的是沉默的证人、被篡改的档案，以及一个似乎比他更了解案件细节的神秘对手。随着调查深入，他逐渐发现真正的凶手一直藏在自己最信任的人身边，而当年那场让他离开警队的意外，也并非巧合。真相与执念在雨夜中交织，究竟谁才是猎物，谁又是猎人。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20noir%20movie%20poster%2C%20rain-soaked%20city%20alley%20at%20night%20with%20a%20lone%20detective%20silhouette%2C%20deep%20navy%20and%20crimson%20red%20lighting%2C%20dramatic%20shadows%2C%20moody%20atmosphere%2C%20abstract%20geometric%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-01&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%2C%20rainy%20neon-lit%20city%20street%20at%20night%20with%20a%20detective%20silhouette%20in%20the%20distance%2C%20deep%20navy%20blue%20atmosphere%20with%20crimson%20red%20reflections%20on%20wet%20asphalt%2C%20dramatic%20film%20lighting%2C%20high%20contrast%2C%20cinematic%20grain%2C%20no%20text&width=1600&height=900&seq=rj-backdrop-01&orientation=landscape',
    popularity: 98200,
    status: '热映中',
    featured: true,
  },
  {
    id: '2',
    title: '星际回响',
    year: 2025,
    rating: 9.1,
    genres: ['科幻', '剧情'],
    director: '顾航',
    actors: ['周砚', '叶澜', '许承'],
    duration: 146,
    region: '中国大陆',
    tagline: '当宇宙回应了人类，我们却听不懂那是问候还是警告。',
    synopsis:
      '在距离地球四十光年的深空站，一名孤独的观测员捕捉到一段规律的信号。这段信号以完美的数学结构重复着，仿佛在等待某个答案。随着解读推进，人类逐渐意识到这并不是来自外星文明的问候，而是来自未来的某种回响——一次关于人类命运的提前预告。观测员不得不在有限的通讯窗口里，说服这个并不团结的世界做出选择，而他自己，也站在了一个无法回头的十字路口。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%2C%20glowing%20planet%20and%20vast%20starfield%20with%20a%20tiny%20astronaut%20silhouette%2C%20deep%20blue%20and%20orange%20nebula%20tones%2C%20dramatic%20cosmic%20lighting%2C%20abstract%20geometric%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-02&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20deep%20space%20panorama%20with%20a%20giant%20glowing%20planet%20and%20swirling%20orange%20and%20blue%20nebula%20clouds%2C%20lone%20spacecraft%20silhouette%20approaching%2C%20dramatic%20cosmic%20lighting%2C%20epic%20scale%2C%20cinematic%20grain%2C%20no%20text&width=1600&height=900&seq=rj-backdrop-02&orientation=landscape',
    popularity: 91400,
    status: '热映中',
    featured: true,
  },
  {
    id: '3',
    title: '雨季告白',
    year: 2024,
    rating: 8.2,
    genres: ['爱情', '剧情'],
    director: '温言',
    actors: ['沈知', '阮小满', '何屹'],
    duration: 112,
    region: '中国大陆',
    tagline: '有些话，只有在下雨的时候才说得出口。',
    synopsis:
      '小城的雨季长达三个月，图书馆管理员沈知每天都会在同一个时间看见撑着红伞的女孩经过窗前。一次偶然的借书登记，让两个本不相干的人有了交集。他们一起躲过雨、分享过同一把伞，也在彼此最狼狈的时刻选择了沉默。当雨季结束，女孩即将离开这座城市，那句始终没有说出口的告白，究竟还来得及吗。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20romance%20movie%20poster%2C%20a%20couple%20under%20a%20red%20umbrella%20on%20a%20rainy%20street%2C%20warm%20amber%20and%20deep%20blue%20tones%2C%20soft%20bokeh%20lights%2C%20melancholic%20mood%2C%20artistic%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-03&orientation=portrait',
    popularity: 73600,
    status: '热播中',
  },
  {
    id: '4',
    title: '铁血防线',
    year: 2025,
    rating: 8.5,
    genres: ['动作', '战争'],
    director: '雷铮',
    actors: ['谭锋', '柳玥', '郑拓'],
    duration: 134,
    region: '中国大陆',
    tagline: '守住这道防线，就是守住身后的万家灯火。',
    synopsis:
      '边境哨所接到一道几乎不可能完成的命令：在没有增援的情况下，守住隘口七十二小时。一支由残兵与新兵混编的小队在老班长谭锋的带领下，用有限的弹药和复杂的地形与装备精良的对手周旋。当补给耗尽、通讯中断，支撑他们坚持下去的，只剩下彼此之间那句朴素的承诺。这是一场关于责任、牺牲与信念的残酷较量。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20war%20action%20movie%20poster%2C%20soldier%20silhouettes%20on%20a%20smoky%20battlefield%2C%20deep%20navy%20sky%20with%20fiery%20orange%20explosions%2C%20dramatic%20high%20contrast%2C%20gritty%20texture%2C%20abstract%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-04&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20war%20panorama%2C%20rugged%20mountain%20pass%20fortification%20at%20dusk%20with%20distant%20orange%20explosion%20glow%2C%20soldier%20silhouettes%20on%20the%20ridge%2C%20deep%20navy%20blue%20sky%2C%20dramatic%20moody%20lighting%2C%20cinematic%20grain%2C%20no%20text&width=1600&height=900&seq=rj-backdrop-04&orientation=landscape',
    popularity: 88300,
    status: '热映中',
    featured: true,
  },
  {
    id: '5',
    title: '笑闹一家亲',
    year: 2024,
    rating: 7.6,
    genres: ['喜剧', '家庭'],
    director: '白乐',
    actors: ['常欢', '蔡芝', '毛豆'],
    duration: 104,
    region: '中国大陆',
    tagline: '一家人凑齐了，麻烦也就到齐了。',
    synopsis:
      '为了给奶奶庆祝八十大寿，散落在各地的一大家子被迫重新聚在老宅。三天的时间里，藏着秘密的二叔、创业失败的表哥、坚持要拆果园的开发商轮番登场。一场原本温馨的生日宴，被一连串啼笑皆非的意外搅成了一场闹剧。可当夜深人静，一家人围坐在一起吃面时，那些解不开的结，似乎也没那么重要了。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20comedy%20movie%20poster%2C%20bright%20colorful%20abstract%20shapes%20and%20confetti%20over%20a%20warm%20background%2C%20playful%20vibrant%20orange%20red%20and%20blue%20palette%2C%20cheerful%20upbeat%20mood%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-05&orientation=portrait',
    popularity: 61200,
    status: '已上线',
  },
  {
    id: '6',
    title: '迷雾山城',
    year: 2025,
    rating: 8.4,
    genres: ['悬疑', '惊悚'],
    director: '秦墨',
    actors: ['傅宁', '安然', '陆行'],
    duration: 121,
    region: '中国大陆',
    tagline: '雾散之后，谁都别想全身而退。',
    synopsis:
      '一座常年被浓雾笼罩的山城，在连续失踪案后彻底与外界隔绝。前往调查的记者安然发现，这里的居民似乎都在刻意回避某段共同的记忆。随着雾气一次次漫过街道，她逐渐拼凑出一个被全镇人共同守护的秘密。而每当她以为自己接近真相，迷雾就会把她带回原点。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20thriller%20movie%20poster%2C%20foggy%20mountain%20town%20at%20dusk%20with%20a%20mysterious%20lone%20figure%2C%20cold%20blue%20mist%20and%20muted%20red%20accents%2C%20eerie%20atmosphere%2C%20abstract%20layered%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-06&orientation=portrait',
    popularity: 82500,
    status: '热映中',
  },
  {
    id: '7',
    title: '深海猎影',
    year: 2024,
    rating: 8.0,
    genres: ['动作', '冒险'],
    director: '江涛',
    actors: ['贺川', '伊娃·森', '罗鸣'],
    duration: 118,
    region: '中国大陆',
    tagline: '在深海里，沉默比咆哮更危险。',
    synopsis:
      '一支深海打捞队在例行作业中偶然发现了一艘沉没多年的货轮，船舱里载着的并非普通货物。队长贺川很快意识到，他们被卷入了一场牵涉多方的博弈。在八百米深的海底，呼吸都成了奢侈品，而水面上等待他们的，是比深海更冷的算计。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20adventure%20movie%20poster%2C%20lone%20diver%20silhouette%20descending%20into%20deep%20dark%20ocean%2C%20deep%20teal%20blue%20with%20orange%20submersible%20lights%2C%20dramatic%20underwater%20lighting%2C%20abstract%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-07&orientation=portrait',
    popularity: 70900,
    status: '已上线',
  },
  {
    id: '8',
    title: '时光信笺',
    year: 2025,
    rating: 8.3,
    genres: ['爱情', '奇幻'],
    director: '温言',
    actors: ['沈知', '阮小满', '顾南'],
    duration: 116,
    region: '中国大陆',
    tagline: '写给过去的一封信，改变了一整个未来。',
    synopsis:
      '整理祖母遗物时，女孩发现了一个刻着日期的旧信箱。她抱着试一试的心情投进一封信，没想到真的收到了来自二十年前的回复。隔着时光，她与年轻时的祖母成了笔友。在一点点改写过去的同时，她也逐渐理解了那些当年无法释怀的告别，究竟意味着什么。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20romance%20movie%20poster%2C%20vintage%20mailbox%20with%20glowing%20letters%20floating%20in%20warm%20light%2C%20soft%20amber%20and%20deep%20blue%20tones%2C%20dreamy%20magical%20atmosphere%2C%20abstract%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-08&orientation=portrait',
    popularity: 77400,
    status: '热映中',
  },
  {
    id: '9',
    title: '荒野末班车',
    year: 2023,
    rating: 7.9,
    genres: ['惊悚', '犯罪'],
    director: '秦岭',
    actors: ['毕天', '钟灵', '马跃'],
    duration: 99,
    region: '中国大陆',
    tagline: '这趟车，没有一个人是无辜的。',
    synopsis:
      '深夜开往边境的末班车上，只有七名乘客。当车驶入无人的荒野，一场突如其来的抛锚让所有人被困在原地。随着行李被翻动、座位被标记，乘客们发现彼此并非陌生人。天亮之前，他们必须弄清楚：谁在说谎，而谁又真正握着这趟车的方向。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20thriller%20movie%20poster%2C%20old%20bus%20on%20a%20dark%20empty%20desert%20road%20at%20night%2C%20headlights%20cutting%20through%20cold%20blue%20darkness%20with%20red%20tail%20glow%2C%20suspenseful%20atmosphere%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-09&orientation=portrait',
    popularity: 58600,
    status: '已上线',
  },
  {
    id: '10',
    title: '云端之城',
    year: 2025,
    rating: 8.6,
    genres: ['动画', '奇幻'],
    director: '何知白',
    actors: ['配音：多多', '配音：江离', '配音：鹿鸣'],
    duration: 96,
    region: '中国大陆',
    tagline: '只要还记得回家的路，天空就不会迷路。',
    synopsis:
      '在悬浮于云层之上的城市里，住着一群以修补彩虹为生的人。少女阿云意外继承了祖母留下的风向仪，也因此被卷入了天空秩序即将崩塌的危机。她必须带着一群性格迥异的伙伴，穿过风暴与极光，找回那座早已被遗忘的空中灯塔。',
    poster:
      'https://readdy.ai/api/search-image?query=Animated%20fantasy%20movie%20poster%2C%20a%20floating%20city%20on%20clouds%20with%20colorful%20hot%20air%20balloons%20and%20aurora%2C%20vivid%20coral%20orange%20and%20deep%20blue%20tones%2C%20whimsical%20magical%20atmosphere%2C%20artistic%20illustration%2C%20no%20text&width=600&height=900&seq=rj-poster-10&orientation=portrait',
    popularity: 84200,
    status: '热映中',
  },
  {
    id: '11',
    title: '沉默证人',
    year: 2024,
    rating: 8.1,
    genres: ['剧情', '悬疑'],
    director: '黎野',
    actors: ['方证', '夏语', '康瑞'],
    duration: 124,
    region: '中国大陆',
    tagline: '有些沉默，比任何证词都更响亮。',
    synopsis:
      '一名坚持为被告辩护的年轻律师接手了一桩证据链完整的案件。唯一的突破口，是一个始终不肯开口的目击者。在一次次徒劳的走访中，他逐渐意识到，沉默本身也许正是这个案件最锋利的真相。当所有人都劝他放弃，他决定用自己的方式，让无声者被听见。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20drama%20movie%20poster%2C%20empty%20courtroom%20with%20a%20single%20empty%20witness%20chair%20under%20a%20beam%20of%20light%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20tense%20quiet%20mood%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-11&orientation=portrait',
    popularity: 64800,
    status: '已上线',
  },
  {
    id: '12',
    title: '燃烧的赛道',
    year: 2025,
    rating: 8.2,
    genres: ['动作', '运动'],
    director: '雷铮',
    actors: ['贺川', '舒宁', '毕天'],
    duration: 122,
    region: '中国大陆',
    tagline: '终点线之前，没有刹车。',
    synopsis:
      '曾经的冠军车手因为一场事故被迫退役，多年后为了守护即将被解散的车队重新握上方向盘。他的对手，正是当年那场事故中失去一切的昔日队友。两代车手在弯道上正面相遇，速度、荣誉与和解在引擎的轰鸣里被推向极限。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20racing%20movie%20poster%2C%20sports%20car%20drifting%20through%20a%20corner%20with%20motion%20blur%20and%20sparks%2C%20vivid%20orange%20red%20and%20deep%20blue%20lighting%2C%20high%20energy%20dynamic%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-12&orientation=portrait',
    popularity: 79100,
    status: '热映中',
  },
  {
    id: '13',
    title: '幽灵电台',
    year: 2024,
    rating: 7.4,
    genres: ['恐怖', '悬疑'],
    director: '秦岭',
    actors: ['钟灵', '傅宁', '白苓'],
    duration: 93,
    region: '中国大陆',
    tagline: '凌晨三点，请勿收听。',
    synopsis:
      '深夜电台的主持人收到一段没有寄件人的录音带。播放之后，她的生活开始出现无法解释的错位——窗外的雨、电话里的声音、镜子里的影子，全部偏离了原来的轨道。为了弄清录音的来源，她不得不一次次将节目重新播出去，而每一个收听的听众，都成了连锁反应的一部分。',
    poster:
      'https://readdy.ai/api/search-image?query=Horror%20movie%20poster%2C%20vintage%20radio%20glowing%20in%20a%20dark%20empty%20room%20with%20faint%20red%20static%20light%2C%20deep%20navy%20and%20crimson%20tones%2C%20eerie%20unsettling%20atmosphere%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-13&orientation=portrait',
    popularity: 55300,
    status: '已上线',
  },
  {
    id: '14',
    title: '长安旧梦',
    year: 2023,
    rating: 8.8,
    genres: ['剧情', '历史'],
    director: '顾航',
    actors: ['周砚', '叶澜', '方证'],
    duration: 148,
    region: '中国大陆',
    tagline: '一座城的兴衰，写在一个人的梦里。',
    synopsis:
      '落魄的书生在一次偶然中得到了半卷残缺的旧城图志。凭着一支笔与一股执拗，他走遍废墟与荒野，试图还原那座早已消失在历史中的都城。在拼凑城郭与街巷的同时，他也重新丈量了自己与国家、与时代之间那段无法言说的距离。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20historical%20drama%20movie%20poster%2C%20ancient%20chinese%20cityscape%20silhouette%20with%20a%20lone%20scholar%20and%20lanterns%2C%20warm%20amber%20and%20deep%20indigo%20tones%2C%20melancholic%20epic%20atmosphere%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-14&orientation=portrait',
    popularity: 87600,
    status: '经典重映',
  },
  {
    id: '15',
    title: '机械黎明',
    year: 2025,
    rating: 8.9,
    genres: ['科幻', '动作'],
    director: '江涛',
    actors: ['谭锋', '伊娃·森', '许承'],
    duration: 139,
    region: '中国大陆',
    tagline: '当机器学会犹豫，人类才开始害怕。',
    synopsis:
      '在自动化程度极高的未来都市里，一名工程师意外发现城市核心系统的决策出现了无法用代码解释的偏差。围绕这台逐渐“学会思考”的机器，企业、政府与地下组织展开了一场看不见硝烟的争夺。工程师必须在天亮之前判断：这道即将到来的曙光，是救赎，还是另一种形式的黄昏。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20action%20movie%20poster%2C%20giant%20humanoid%20machine%20silhouette%20against%20a%20glowing%20orange%20sunrise%20cityscape%2C%20deep%20blue%20metallic%20tones%2C%20futuristic%20dramatic%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-15&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20futuristic%20city%20skyline%20at%20dawn%20with%20a%20colossal%20machine%20silhouette%20looming%20over%20glowing%20streets%2C%20warm%20orange%20sunrise%20against%20deep%20blue%20shadows%2C%20epic%20sci-fi%20scale%2C%20cinematic%20grain%2C%20no%20text&width=1600&height=900&seq=rj-backdrop-15&orientation=landscape',
    popularity: 93100,
    status: '热映中',
    featured: true,
  },
  {
    id: '16',
    title: '幸运硬币',
    year: 2024,
    rating: 7.7,
    genres: ['喜剧', '爱情'],
    director: '白乐',
    actors: ['常欢', '舒宁', '毛豆'],
    duration: 101,
    region: '中国大陆',
    tagline: '把好运全押在一个人身上，你敢吗。',
    synopsis:
      '一个总把决定交给硬币的胆小青年，在一次抛硬币的赌约里稀里糊涂住进了陌生女孩的家。两人约定各自用一枚硬币决定接下来一周的所有选择，却在一次次看似荒诞的随机里，慢慢把彼此变成了对方最确定的答案。',
    poster:
      'https://readdy.ai/api/search-image?query=Romantic%20comedy%20movie%20poster%2C%20a%20golden%20coin%20spinning%20in%20mid-air%20with%20warm%20bokeh%20city%20lights%20behind%2C%20playful%20coral%20orange%20and%20blue%20palette%2C%20cheerful%20light%20mood%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-16&orientation=portrait',
    popularity: 62400,
    status: '已上线',
  },
  {
    id: '17',
    title: '血色证据',
    year: 2025,
    rating: 8.5,
    genres: ['犯罪', '剧情'],
    director: '黎野',
    actors: ['方证', '安然', '郑拓'],
    duration: 126,
    region: '中国大陆',
    tagline: '证据不会说谎，但持有证据的人会。',
    synopsis:
      '一桩看似普通的案件，因为一份来历不明的证据变得扑朔迷离。检察官在追查真相的过程中，发现自己逐渐被卷入了一张由权力与谎言编织的网。当所有人都在劝他就此收手，他决定用职业生涯做一次豪赌，去赌那一点点仅存的光。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20crime%20drama%20movie%20poster%2C%20close-up%20of%20a%20blood-red%20sealed%20evidence%20envelope%20on%20a%20dark%20desk%2C%20deep%20navy%20and%20crimson%20tones%2C%20tense%20high%20contrast%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-17&orientation=portrait',
    popularity: 80300,
    status: '热映中',
  },
  {
    id: '18',
    title: '星尘旅人',
    year: 2024,
    rating: 8.3,
    genres: ['科幻', '冒险'],
    director: '何知白',
    actors: ['周砚', '鹿鸣', '罗鸣'],
    duration: 131,
    region: '中国大陆',
    tagline: '我们终将化作星尘，但此刻仍要远行。',
    synopsis:
      '一群来自不同星球背景的旅人，为了各自的理由登上了同一艘老旧飞船。他们穿越陨石带、穿越寂静的星云，也在一次次险境里学会了信任。当终点近在眼前，他们才明白这趟旅程真正要找的，从来不是某个坐标，而是愿意同行的人。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20space%20adventure%20movie%20poster%2C%20a%20small%20vintage%20spaceship%20sailing%20through%20colorful%20stardust%20and%20rings%20of%20a%20planet%2C%20violet-free%20deep%20blue%20and%20warm%20orange%20tones%2C%20wondrous%20atmosphere%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-18&orientation=portrait',
    popularity: 68700,
    status: '已上线',
  },
  {
    id: '19',
    title: '春日食堂',
    year: 2025,
    rating: 8.4,
    genres: ['剧情', '治愈'],
    director: '温言',
    actors: ['蔡芝', '陆行', '白苓'],
    duration: 108,
    region: '中国大陆',
    tagline: '一碗热汤，足以熬过一个冬天。',
    synopsis:
      '在老街的转角，有一家只在春天营业的小食堂。老板话不多，却记得每位客人的口味和心事。从加班到深夜的年轻人，到独自过生日的老先生，每一个推开木门的人，都带着自己的故事。而食堂回赠给他们的，是一份被认真对待的温暖。',
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20healing%20drama%20movie%20poster%2C%20cozy%20small%20food%20stall%20glowing%20with%20warm%20lanterns%20and%20steam%2C%20soft%20amber%20and%20deep%20blue%20evening%20tones%2C%20gentle%20comforting%20atmosphere%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-19&orientation=portrait',
    popularity: 66300,
    status: '热映中',
  },
  {
    id: '20',
    title: '极地救援',
    year: 2024,
    rating: 8.6,
    genres: ['动作', '灾难'],
    director: '雷铮',
    actors: ['谭锋', '伊娃·森', '贺川'],
    duration: 130,
    region: '中国大陆',
    tagline: '在零下四十度，唯一的敌人是时间。',
    synopsis:
      '一场突如其来的冰崩将极地科考站与外界彻底切断。一支临时组建的救援小队顶着暴风雪挺进无人区，要在氧气耗尽之前找到被困的队员。极寒、雪盲与不断崩塌的冰层，让每一步都可能是最后一步。而他们能依靠的，只有彼此。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20disaster%20movie%20poster%2C%20tiny%20rescue%20team%20silhouettes%20crossing%20a%20vast%20snowstorm%20in%20a%20frozen%20landscape%2C%20cold%20icy%20blue%20with%20a%20faint%20orange%20sun%20glow%2C%20dramatic%20epic%20scale%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-20&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20arctic%20panorama%2C%20a%20rescue%20helicopter%20over%20endless%20snow%20and%20cracked%20ice%20fields%20under%20a%20low%20orange%20sun%2C%20deep%20blue%20cold%20shadows%2C%20dramatic%20epic%20scale%2C%20cinematic%20grain%2C%20no%20text&width=1600&height=900&seq=rj-backdrop-20&orientation=landscape',
    popularity: 85700,
    status: '已上线',
    featured: true,
  },
  {
    id: '21',
    title: '双面人生',
    year: 2025,
    rating: 8.7,
    genres: ['悬疑', '剧情'],
    director: '秦墨',
    actors: ['傅宁', '夏语', '康瑞'],
    duration: 127,
    region: '中国大陆',
    tagline: '镜子里的那个人，才是我。',
    synopsis:
      '过着平凡生活的上班族，在某个清晨发现自己拥有了一个截然不同的身份。两段人生交替上演，记忆开始互相渗透。当他试图找出哪一个才是真实的自己时，却发现两边的世界都有人在等他做出同一个选择——而那个选择，可能会让另一个人消失。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20psychological%20thriller%20movie%20poster%2C%20a%20man%20facing%20a%20cracked%20mirror%20reflecting%20two%20different%20silhouettes%2C%20deep%20navy%20and%20crimson%20tones%2C%20surreal%20tense%20atmosphere%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-21&orientation=portrait',
    popularity: 83900,
    status: '热映中',
  },
  {
    id: '22',
    title: '风起江湖',
    year: 2023,
    rating: 8.5,
    genres: ['动作', '武侠'],
    director: '顾航',
    actors: ['谭锋', '柳玥', '许承'],
    duration: 133,
    region: '中国大陆',
    tagline: '刀出鞘的时候，恩怨就该有个了结。',
    synopsis:
      '退隐多年的剑客因一封故人的求救信重出江湖。昔日并肩的兄弟如今分道扬镳，一个成了高居庙堂的权贵，一个沦落为被通缉的叛徒。在这场关于义气与道义的抉择里，剑客必须重新定义，什么才是真正值得用生命去守护的东西。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20martial%20arts%20movie%20poster%2C%20a%20lone%20swordsman%20silhouette%20on%20a%20cliff%20at%20dusk%20with%20flowing%20robes%2C%20deep%20indigo%20blue%20with%20warm%20orange%20sunset%20glow%2C%20dramatic%20wuxia%20atmosphere%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-22&orientation=portrait',
    popularity: 73200,
    status: '经典重映',
  },
  {
    id: '23',
    title: '午夜琴声',
    year: 2025,
    rating: 7.5,
    genres: ['恐怖', '惊悚'],
    director: '秦岭',
    actors: ['白苓', '钟灵', '马跃'],
    duration: 97,
    region: '中国大陆',
    tagline: '听见琴声的人，都会忘记一首曲子。',
    synopsis:
      '一所即将停办的旧音乐学院里，每逢午夜都会传出钢琴声。新来的调音师起初以为只是学生练习，直到他发现琴房的地板下，藏着一份早已被遗忘的演奏名录。每弹奏一首曲子，就会有人忘记一段记忆。而名单上的最后一个名字，竟然是他自己。',
    poster:
      'https://readdy.ai/api/search-image?query=Horror%20movie%20poster%2C%20an%20abandoned%20grand%20piano%20in%20a%20dark%20room%20with%20candlelight%20and%20floating%20dust%2C%20deep%20navy%20and%20crimson%20red%20tones%2C%20eerie%20unsettling%20atmosphere%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-23&orientation=portrait',
    popularity: 57100,
    status: '已上线',
  },
  {
    id: '24',
    title: '星河恋曲',
    year: 2025,
    rating: 8.4,
    genres: ['爱情', '科幻'],
    director: '顾航',
    actors: ['叶澜', '周砚', '舒宁'],
    duration: 120,
    region: '中国大陆',
    tagline: '跨越四光年的等待，只为一次重逢。',
    synopsis:
      '一对恋人因为一场深空任务被迫分离，彼此的通讯需要跨越四年的延迟。她在信里写下今天的天气，他收到时已是四年后的冬天。当时间被拉得如此漫长，爱情究竟是被稀释，还是被淬炼得更加坚定。这是关于距离、耐心与信念的一场漫长告白。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20romantic%20sci-fi%20movie%20poster%2C%20two%20lovers%20silhouettes%20facing%20each%20other%20with%20a%20giant%20planet%20and%20glowing%20star%20field%20between%20them%2C%20warm%20orange%20and%20deep%20blue%20tones%2C%20poetic%20dreamy%20atmosphere%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=rj-poster-24&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20romantic%20space%20scene%2C%20two%20distant%20silhouettes%20reaching%20toward%20each%20other%20across%20a%20vast%20glowing%20star%20field%20with%20a%20huge%20planet%2C%20warm%20orange%20nebula%20against%20deep%20blue%20cosmos%2C%20poetic%20cinematic%20grain%2C%20no%20text&width=1600&height=900&seq=rj-backdrop-24&orientation=landscape',
    popularity: 89900,
    status: '热映中',
    featured: true,
  },
];

export const featuredMovieIds = ['1', '2', '4', '15', '20', '24'];